import { apiRequestInitState } from "../constants";
import {
  REQUEST_GET_REQUEST_LIST,
  SUCCESS_GET_REQUEST_LIST,
  FAILURE_GET_REQUEST_LIST,
} from "./actions";

export const requestList =(state = apiRequestInitState, action) => {
  switch (action.type) {
    case REQUEST_GET_REQUEST_LIST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case SUCCESS_GET_REQUEST_LIST:
      return {
        ...state,
        isFetching: false,
        payload: action.payload,
        error: null
      };
    case FAILURE_GET_REQUEST_LIST:
      return {
        ...state,
        isFetching: false,
        payload: null,
        error: action.error
      };
    default:
      return state;
  }
}

